// Constants for logger function calls to avoid SonarLint duplicate string warnings

// Button click events
export const KNAPP_KLIKKET = 'knapp klikket'
// TODO: fjern når amplitude er ikke i bruk lenger
export const BUTTON_KLIKK = 'button click'

// Form validation events
export const SKJEMA_VALIDERING_FEILET = 'skjemavalidering feilet'
export const SKJEMA_VALIDERING_FEILET_OLD = 'skjema validering feilet' // TODO: fjern når amplitude er ikke i bruk lenger

// Radio group selection events
export const RADIOGROUP_VALGT = 'radiogroup valgt'

// Modal opening events
export const MODAL_AAPNET = 'modal åpnet'

// Link opening events
export const LINK_AAPNET = 'lenke klikket'
export const LINK_AAPNET_OLD = 'link åpnet' // TODO: fjern når amplitude er ikke i bruk lenger

// Selection events
export const NEDTREKKSISTE_VALG_ENDRET = 'nedtrekksliste valg endret'

// UI interaction events
export const GRAF_TOOLTIP_AAPNET = 'graf tooltip åpnet'
export const GRUNNLAG_FOR_BEREGNINGEN = 'grunnlag for beregningen'
export const SHOW_MORE_AAPNET = 'show more åpnet'
export const SHOW_MORE_LUKKET = 'show more lukket'
export const ALERT_VIST = 'alert vist'
